import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, timer } from "rxjs";
import { concatMap, takeWhile, catchError, map, tap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { UtilityService } from "./utility.service";

@Injectable({
  providedIn: 'root',
})
export class FireflyService {
  private apiUrl = `${environment.apiUrl}/firefly`;

  constructor(private http: HttpClient, private utilityService: UtilityService) { }

  generateAsync(requestBody: any): Observable<any> {
    return this.http
      .post(`${this.apiUrl}/generate-async`, requestBody)
      .pipe(catchError(this.utilityService.handleError));
  }

  generateAsyncIm5(requestBody: any): Observable<any> {
    return this.http
      .post(`${this.apiUrl}/generate-async-im5`, requestBody)
      .pipe(catchError(this.utilityService.handleError));
  }

  generateVideoAsyncV3(requestBody: any): Observable<any> {
    return this.http
      .post(`${this.apiUrl}/generate-video-async/v3`, requestBody)
      .pipe(catchError(this.utilityService.handleError));
  }

  expandImageAsync(requestBody: any): Observable<any> {
    return this.http
      .post(`${this.apiUrl}/expand-async`, requestBody)
      .pipe(catchError(this.utilityService.handleError));
  }

  fillImageAsync(requestBody: any): Observable<any> {
    return this.http
      .post(`${this.apiUrl}/fill-async`, requestBody)
      .pipe(catchError(this.utilityService.handleError));
  }

  uploadFile(fileBlob: Blob): Observable<any> {
    const contentType = fileBlob.type || 'image/png';
    const headers = new HttpHeaders({ 'Content-Type': contentType });
    return this.http
      .post(`${this.apiUrl}/file-upload`, fileBlob, { headers })
      .pipe(catchError(this.utilityService.handleError));
  }

  getCustomModels(options?: {
    sortBy?: string,
    start?: number,
    limit?: number,
    publishedState?: string
  }): Observable<any> {
    let params = new HttpParams();

    if (options) {
      if (options.sortBy) params = params.append('sortBy', options.sortBy);
      if (options.start !== undefined) params = params.append('start', options.start.toString());
      if (options.limit) params = params.append('limit', options.limit.toString());
      if (options.publishedState) params = params.append('publishedState', options.publishedState);
    }

    return this.http
      .get(`${this.apiUrl}/custom-models`, { params })
      .pipe(catchError(this.utilityService.handleError));
  }

  getJobStatus(jobId: string): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/status/${jobId}`)
      .pipe(catchError(this.utilityService.handleError));
  }

  pollJobStatus(jobId: string, intervalMs: number = 3000, maxAttempts: number = 60): Observable<any> {
    let attempts = 0;

    return timer(0, intervalMs).pipe(
      concatMap(() => {
        attempts++;
        return this.getJobStatus(jobId);
      }),
      tap(response => {
        console.log(`ポーリング試行 ${attempts}/${maxAttempts}:`, response);
      }),
      map(response => {
        if (!response.success) {
          throw new Error('ジョブステータスの取得に失敗しました');
        }
        return response;
      }),
      takeWhile(result => {
        return (result.status === 'running' || result.status === 'pending') &&
          attempts < maxAttempts;
      }, true),
      catchError(error => {
        console.error('ジョブステータスのポーリングエラー:', error);
        return throwError(() => new Error(`ジョブステータスの取得に失敗しました: ${error.message}`));
      })
    );
  }
}